export default (superclass) => class extends superclass {
    initialize(models, options = {}) {
        if (options.pagination !== false) {
            this.pagination = Object.assign({
                page: 0,
                rowsPerPage: 30
            }, options.pagination || {});
        }

        return super.initialize(...arguments);
    }

    fetchPage(n = null, options = {}) {
        if (n !== null) {
            this.pagination.page = n;
        }
        return this.fetch(options);
    }

    fetch(options = {}) {
        if (!this.pagination) {
            return super.fetch(options);
        }

        let where = (options.filter || {}).where;
        if (where && typeof where === 'object') {
            this._where = where;
        }

        if (this.pagination.page < 0) {
            this.pagination.page = 0;
            return Promise.resolve(this);
        }

        return this.count(this._where).then(count => {
            this.pagination.count = count;
            this.pagination.pages = Math.ceil(
                count / this.pagination.rowsPerPage
            );

            if (this.pagination.page > this.pagination.pages - 1) {
                this.pagination.page = this.pagination.pages - 1;
                this.trigger('sync');
                return Promise.resolve(this);
            }

            this.pagination.limit = this.pagination.rowsPerPage;
            this.pagination.offset = (
                this.pagination.page * this.pagination.rowsPerPage
            );

            const filter = Object.assign(options.filter || {}, {
                where: this._where ? this._where : undefined,
                limit: this.pagination.limit,
                offset: this.pagination.offset
            });
            return super.fetch(Object.assign({}, options, {filter}));
        });
    }

    nextPage(options = {}) {
        return this.fetchPage(this.pagination.page + 1, options);
    }

    prevPage(options = {}) {
        return this.fetchPage(this.pagination.page - 1, options);
    }

    getPaginationInfo() {
        return this.pagination;
    }
};




// WEBPACK FOOTER //
// ./app/new-collections/mixins/paginatable.js